<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">User Logs</h4>
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">User Logs!</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="body">
            <div class="responsive_table">
              <div class="materialTableHeader " style="height: 130px;">
                <div class="row">
                  <ul class="header-buttons-left ml-0 ">
                    <li class="filter-background m-l-15">
                      <mat-form-field appearance="outline" class="filter-input">
                        <mat-label>Filter by Login Status</mat-label>
                        <select matNativeControl [(ngModel)]="filterByActivity" (ngModelChange)="resetPaginator()">
                          <option value="LOGGED_IN">LOGGED IN</option>
                          <option value="NOT_LOGGED_IN" selected>NOT LOGGED IN</option>
                        </select>
                      </mat-form-field>
                    </li>
                    <li class="filter-background m-l-15">
                      <mat-form-field appearance="outline" class="filter-input">
                        <mat-label>Filter by App name</mat-label>
                        <select matNativeControl [(ngModel)]="appId" (change)="getSelectedApp(appId)">
                          <option [value]="app._id" *ngFor="let app of clientApps" style="margin-left: 2px;">
                            {{app.application_name}}</option>
                        </select>
                      </mat-form-field>
                    </li>
                    <li class="filter-background m-l-15">
                      <mat-form-field class="filter-input" appearance="outline">
                        <mat-label>Filter by ROLES</mat-label>
                        <select matNativeControl [(ngModel)]="selectedRoleId" (change)="saveRoleName()">
                          <option [value]=null>ALL ROLES</option>
                          <option [value]="role._id" *ngFor="let role of rolesList">{{role.name}}</option>
                        </select>
                      </mat-form-field>
                    </li>
                    <li class="dropdown m-l-15">
                      <label for="search-input">
                        <i class="material-icons search-icon">search</i></label>
                      <input placeholder="Search" type="text" #input class="browser-default search-field"
                        aria-label="Search box" [(ngModel)]="userNameFilter"
                        (ngModelChange)="userNameFilter = $event.trim()" />
                    </li>
                    <li class="date-background m-l-15">
                      <mat-form-field class="filter-input" appearance="outline">
                        <mat-label>Enter a date range</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                          <input matStartDate matInput placeholder="From" [max]="maxDate" [(ngModel)]="startDate">
                          <input matEndDate matInput placeholder="To" [(ngModel)]="endDate" [max]="maxDate">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                      </mat-form-field>
                    </li>
                  </ul>
                </div>
                <ul class="d-flex justify-content-end m-r-35" style="margin-top: 70px;">
                  <li class="">
                    <div class="icon-button-demo " style="margin-left: 10%;">
                      <button mat-icon-button color="primary" class="btn-tbl-add" matTooltip="Search">
                        <mat-icon aria-label="Reset all filters" class="col-white"
                          (click)="searchFilters()">arrow_forward</mat-icon>
                      </button>
                    </div>
                  </li>
                  <li>
                    <div class=" m-l-20">
                      <button mat-icon-button color="accent" class="btn-tbl-cancel" matTooltip="Reset all filters">
                        <mat-icon aria-label="Reset all filters" class="col-white"
                          (click)="resetFilters()">autorenew</mat-icon>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="table-img mt-1 d-flex justify-content-end"   >
                <img src="./assets/images/banner/xlsx.png" alt="" style="cursor: pointer" matTooltip="Download report"
                  (click)="downloadReport('xlsx')" />
              </div>
              <mat-table [dataSource]="dataSource" matSort matSortActive="email_id" matSortDirection="asc"
                class="mat-cell" >
                <ng-container matColumnDef="firstname">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="firstname" [ngClass]="'tbl-col-width-per-15'">NAME
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" [ngClass]="'tbl-col-width-per-15'">
                    <strong> {{element?.firstname }}&nbsp;{{ element?.lastname }} </strong>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="email_id">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="email_id" [ngClass]="'tbl-col-width-per-25'">EMAIL
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" [ngClass]="'tbl-col-width-per-25'">
                    {{element.email_id ||'N/A'}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="loginDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="loginDate" [ngClass]="'tbl-col-width-per-15'">LOGIN DATE
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" [ngClass]="'tbl-col-width-per-15'">
                    {{ element.loginDate ? (element.loginDate | date:'medium') : (element.latestLoginDate ?
                    (element.latestLoginDate |date:'medium' ) : 'N/A') }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="applicationName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="application_name"
                    [ngClass]="'tbl-col-width-per-15'"> APPLICATION NAME
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" [ngClass]="'tbl-col-width-per-15'">
                    {{element?.application_name || selectedAppName|| 'N/A'}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="roles">
                  <mat-header-cell *matHeaderCellDef
                    [ngClass]="'tbl-col-width-per-15'"> ROLES
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" [ngClass]="'tbl-col-width-per-15'">
                    <div *ngIf="element.roles?.length !==0" class="d-flex">
                      <span class="role-label col-green  ms-1"  style="margin-left: 3px;" *ngFor="let role of element.roles">
                        <span class="position">{{ (role?.name|| 'N/A') | uppercase }}</span>
                      </span>
                    </div>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="platform">
                  <mat-header-cell *matHeaderCellDef
                    [ngClass]="'tbl-col-width-per-15'"
                    [ngStyle]="{ 'display': showCols !== 'NOT_LOGGED_IN' ? 'table-cell' : 'none' }">
                    PLATFORM
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" [ngClass]="'tbl-col-width-per-15'"
                    [ngStyle]="{ 'display': showCols !== 'NOT_LOGGED_IN' ? 'table-cell' : 'none' }">
                    {{ element?.os }}&nbsp;{{ element?.family }}</mat-cell>
                </ng-container>
                <div >
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell pt-3 text-muted  " style="width:100vw; text-align:center;">No data found</td>
                  </tr>
                </div>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let element; columns: displayedColumns"  matRipple>
                </mat-row>
              </mat-table>
              <div *ngIf="isLoading" class="tbl-spinner  "
                style=" margin-top: 40px; position: relative; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
                </mat-progress-spinner>
              </div>
              <mat-paginator [pageSizeOptions]="[10, 20,30,40,50, 100]" [length]="totalRecords"
                [pageIndex]="defaultPageNumber" showFirstLastButtons #paginator></mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
